import { loadingAsyncState } from 'widgets-for-react'
import { canSafelyCast, TypeCastingValidator } from '../../../../utils/safe-type-casting'

async function createCollection(
  name: string,
  description: string
): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch('/api/v1/collections/Create', {
    method: 'post',
    headers: headers,
    body: JSON.stringify({ Name: name, Description: description }),
  })
  if (!res.ok) throw Error(res.statusText)
  var result = await res.json()
  return result
}

type CreateCollectionResponse = { Id: string }
const idValidator: TypeCastingValidator<CreateCollectionResponse> = {
  kind: 'object',
  fieldsValidator: { Id: { kind: 'string' } },
}

export const loadCreateCollection = (name: string, description: string) =>
  loadingAsyncState(() =>
    createCollection(name, description).then((raw) => {
      const maybeId = canSafelyCast<CreateCollectionResponse>(idValidator, raw)
      return maybeId.kind == 'r'
        ? {
            kind: 'result',
            value: maybeId.v.Id,
            status: 200,
          }
        : { kind: 'failed', status: 200 }
    })
  )

async function editCollection(
  id: string,
  name: string,
  description: string
): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch('/api/v1/collections/Update', {
    method: 'post',
    headers: headers,
    body: JSON.stringify({ Id: id, Name: name, Description: description }),
  })
  if (!res.ok) throw Error(res.statusText)
  return
}

export const loadEditCollection = (
  id: string,
  name: string,
  description: string
) =>
  loadingAsyncState(() =>
    editCollection(id, name, description).then(() => ({
      kind: 'result',
      value: {},
      status: 200,
    }))
  )
